export const CONNECTION_TYPES = {
    ADMIN: 1,
    JOB: 2
}

export const UPDATE_SESSION_INTERVAL = 1200000;